export default __webpack_public_path__ + "3094528d28a66a2868f96e3775eba4df.svg";